import React from 'react';

export default function CategoryItemIcon({
  preview,
  sortable,
  isTypeisEnable,
  itemValue,
  toggleItemStatus,
}) {
  if (preview) {
    return null;
  }

  if (isTypeisEnable) {
    if (sortable) {
      return <i className="fa fa-bars draggable cursor-pointer kt-margin-r-10" />;
    }
    return <span style={{width: '14px', marginRight: '10px'}} />;
  }

  return (
    <i
      className="fa fa-plus draggable cursor-pointer kt-margin-r-10"
      onClick={() => toggleItemStatus(itemValue, 'enable', false, true)}
    />
  );
}
